import { render, staticRenderFns } from "./palestine.vue?vue&type=template&id=43d76d20&scoped=true&"
import script from "./palestine.vue?vue&type=script&lang=js&"
export * from "./palestine.vue?vue&type=script&lang=js&"
import style0 from "./palestine.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./palestine.vue?vue&type=style&index=1&id=43d76d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d76d20",
  null
  
)

export default component.exports